export default __webpack_public_path__ + "static/media/Rectangle 1106.33919748.png";